

const IABCMPID = 0;

const host = "auth.iamnet.ph";
const protocol = "https";
const suffix = "consent/";

//https://iabeurope.eu/vendor-list-tcf/
const tcfvendorlist = [
	{
		"name": "Google Advertising Products",
		"vendorid": 755,
		"purposeidlist": [1,3,4,7,9,10]
	}
];

const tcfnonvendorlist = [
];

const TABS_ENABLED = {
	cookie_settings: true,
	// vendor: false, TODO
	data_request: false, // TODO
}

/*
 * Note:
 * If a category is enabled, it will show the corresponding section in the Cookie Settings
 * If no categories is enabled, it will show only the minimal banner with no option to customize
 */
const CATEGORIES_ENABLED = {
	essential: true,
	storage: false,
	analytics: true,
	ads: false,
}



export default {
	IABCMPID,
	host,
	protocol,
	suffix,
	tcfvendorlist,
	tcfnonvendorlist,
	CATEGORIES_ENABLED,
	TABS_ENABLED,
};

